import { useCallback } from 'react'
import { EditableGridCell, GridCellKind, GridColumn, Item } from '@glideapps/glide-data-grid'
import { UserWithMetadata } from 'Services/apiResponseTypes'
import { CellChange, GridColumnKind, changeKey, originalValueFor } from '../gridModel'

export const useGridCellContent = (
  users: UserWithMetadata[],
  columns: GridColumn[],
  columnKinds: GridColumnKind[],
  changes: Map<string, CellChange>,
  validationErrors: Map<string, string>
) => {
  const getCellContent = useCallback(
    (cell: Item): EditableGridCell => {
      const [col, row] = cell
      const user = users[row]
      const column = columns[col]
      const columnType = columnKinds[col]

      if (!user || !column) {
        return { kind: GridCellKind.Text, data: '', displayData: '', allowOverlay: false }
      }

      const field = column.id as string
      const isEditable = columnType !== 'readonly'
      const key = changeKey(user.user_id, columnType, field)
      const change = changes.get(key)
      const validationError = validationErrors.get(key)

      const value = (change ? change.newValue : originalValueFor(user, columnType, field)) || ''

      return {
        kind: GridCellKind.Text,
        data: value,
        displayData: value,
        allowOverlay: isEditable,
        readonly: !isEditable,
        contentAlign: 'left' as const,
        themeOverride: validationError
          ? {
              bgCell: '#fee2e2',
              textDark: '#dc2626'
            }
          : change
          ? {
              bgCell: '#fff3cd',
              textDark: '#856404'
            }
          : !isEditable
          ? {
              bgCell: '#f5f5f5',
              textDark: '#9ca3af'
            }
          : undefined
      }
    },
    [users, columns, columnKinds, changes, validationErrors]
  )

  return { getCellContent }
}
